<template>
    <schedule mode="participant" />
</template>

<script>
import { mapMutations } from 'vuex';
import Schedule from '@/modules/event/components/card/service/schedule/Schedule';

export default {
    name: 'EventServiceAddParticipant',
    components: { Schedule },

    mounted() {
        this.setScheduleMode({ mode: 'participant' });
    },

    methods: {
        ...mapMutations('event/service/schedule', [
            'setScheduleMode'
        ])
    }
};
</script>
